import type { IPlatformDashboardRepository } from '@domain/data-contracts/platform-dashboard-repository.interface';
import type { ILabAdminRepository } from '@domain/data-contracts/lab-admin-repository.interface';
import type { IScanConnectionRepository } from '@domain/data-contracts/scan-connection-repository.interface';
import type { PlatformKpis } from '@domain/models/platform-kpis.interface';
import { ScanConnectionStatus } from '@domain/models/scan-connection.interface';
import { aggregatePlatformConnections } from './platform-connection-aggregator';

export class PlatformDashboardRepository implements IPlatformDashboardRepository {
  public constructor(
    private readonly labAdminRepository: ILabAdminRepository,
    private readonly scanConnectionRepository: IScanConnectionRepository,
  ) {}

  public async getKpis(signal?: AbortSignal): Promise<PlatformKpis> {
    const labs = await this.labAdminRepository.listAll(signal);
    const rows = await aggregatePlatformConnections(labs, this.scanConnectionRepository, signal);

    let totalConnections = 0;
    let activeConnections = 0;
    const connectionsByProvider: Record<string, number> = {};

    for (const { connections } of rows) {
      for (const conn of connections) {
        totalConnections += 1;
        if (conn.status === ScanConnectionStatus.Active) {
          activeConnections += 1;
        }
        connectionsByProvider[conn.provider] =
          (connectionsByProvider[conn.provider] ?? 0) + 1;
      }
    }

    return {
      totalLabs: labs.length,
      activeLabs: labs.filter((l) => l.isActive).length,
      inactiveLabs: labs.filter((l) => !l.isActive).length,
      totalConnections,
      activeConnections,
      inactiveConnections: totalConnections - activeConnections,
      connectionsByProvider,
    };
  }
}
